import { render, staticRenderFns } from "./DragHeader.vue?vue&type=template&id=d6f3b340&scoped=true&"
var script = {}
import style0 from "./DragHeader.vue?vue&type=style&index=0&id=d6f3b340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f3b340",
  null
  
)

export default component.exports